const LOCALSTORAGE_KEY = "qrcodeReaderId";

export const getReaderId = (): string => {
  try {
    return localStorage.getItem(LOCALSTORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};

export const setReaderId = (id: string) => {
  localStorage.setItem(LOCALSTORAGE_KEY, id);
};
